/**
 * @fileoverview Postal-code select and profile toggle for the second company address.
 */

import React from "react";
import { IconButton } from "@mui/material";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import styles from "./Location.module.css";
import Select from "react-select";
import { logger } from "../../../utils/logger.js";
import { getLocationSelectStyles, getSafeSelectedOption } from "./locationSelectUtils";
import {
  CURSOR_NOT_ALLOWED,
  SHOW_IN_PROFILE_KEY,
  TOGGLE_COLOR_ACTIVE,
  TOGGLE_COLOR_INACTIVE,
} from "./locationConstants";

const SecondAddressPostalSelect = ({ model, t }) => {
  const {
    handleInputChange, handleToggleChange,
    isAddressReadOnly, secondAddressZipCodeRef,
    secondAddressNeighborhoodRef, secondAddressZipCodes,
    segundoDomicilioCodigoPostal, setSegundoDomicilioCodigoPostal,
    segundoDomicilioMostrarCodigoPostal, setSegundoDomicilioMostrarCodigoPostal,
  } = model;

  return (
    <div className={`${styles.inputGroup} ${styles.twoLabelsGroup}`}>
      <div className={styles.inputGroup}>
        <label className={styles.inputLabel}>
          {t("components.location.postalCodeLabel")}
        </label>
        <Select
          ref={secondAddressZipCodeRef}
          isSearchable={true}
          isDisabled={true}
          value={getSafeSelectedOption(
            secondAddressZipCodes,
            segundoDomicilioCodigoPostal,
          )}
          onChange={(selectedOption) => {
            logger.info("+++ Second ZipCode selectedOption:", {
              data: selectedOption,
            });
            if (!selectedOption) {
              return;
            }

            setSegundoDomicilioCodigoPostal(selectedOption._id);
            handleInputChange("domicilio2CodigoPostal", selectedOption._id);

            // Clear dependent fields
            secondAddressNeighborhoodRef.current.clearValue();
          }}
          options={secondAddressZipCodes}
          placeholder={t("components.location.postalCodePlaceholder")}
          styles={getLocationSelectStyles()}
          className="select__control"
          getOptionValue={(option) => option._id}
          formatOptionLabel={(option) => <span>{option.codigo}</span>}
        />
        <div className={styles.showInProfileContainer}>
          <span className={styles.showInProfileText}>
            {t(SHOW_IN_PROFILE_KEY)}
          </span>
          <IconButton
            onClick={() => {
              setSegundoDomicilioMostrarCodigoPostal(
                !segundoDomicilioMostrarCodigoPostal,
              );
              handleToggleChange(
                "domicilio2MostrarCodigoPostal",
                !segundoDomicilioMostrarCodigoPostal,
              );
            }}
            size="small"
            disabled={isAddressReadOnly}
            className={styles.toggleButton}
            sx={{
              "&.Mui-disabled": {
                cursor: CURSOR_NOT_ALLOWED,
                pointerEvents: "auto",
              },
              "& .MuiSvgIcon-root": {
                color: segundoDomicilioMostrarCodigoPostal
                  ? TOGGLE_COLOR_ACTIVE
                  : TOGGLE_COLOR_INACTIVE,
              },
            }}
          >
            {segundoDomicilioMostrarCodigoPostal ? (
              <ToggleOnIcon />
            ) : (
              <ToggleOffIcon />
            )}
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default SecondAddressPostalSelect;
